exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3rEzR{margin-top:5%;padding-left:10%;padding-bottom:20%}._1o7EP,._1xfiT{font-family:roboto\\, Medium}._1o7EP{font-size:10pt}a{text-decoration:inherit}a,a:hover,a:not([href]):not([tabindex]){color:red}", ""]);

// exports
exports.locals = {
	"root": "_3rEzR",
	"btnClickForward": "_1xfiT",
	"text": "_1o7EP"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/routes/telemedicina/ErrorConexionVideoLlamada/styles.css
// module id = 1339
// module chunks = 0 1